import React, { useRef, useState } from "react";
import { useLanguage } from "./languageContext";
import translations from "./translation.json";
import Navbar from "./navbar";
import * as Yup from "yup";
import { Formik, Form, Field, ErrorMessage } from "formik";
import Select from "react-select";
import { toast } from "react-toastify";
import { ApiUrl } from "./ApiUrl";
import { useNavigate } from "react-router-dom";
import ChangePasswordModal from "./ChangePasswordModal";
import { externalUsers } from "./constants/userTypes";
const normalizePhone = (phone) => {
  if (!phone) return "";
  return phone.replace(/\D/g, "").slice(-10);
};

const formatPhoneDisplay = (phone) => {
  if (!phone) return "";
  const digits = phone.replace(/\D/g, "").slice(-10);
  return digits ? `+1 ${digits}` : "";
};
function UserProfile({ isDarkMode, setIsDarkMode, setIsLoading }) {
  const { language } = useLanguage();
  const pageTranslations = translations["userProfilePage"];
  const [token, setToken] = useState(localStorage.getItem("token"));
  const [edit, setEdit] = useState(false);
  const [valid, setValid] = useState(false);
  const [userData, setUserData] = useState(
    JSON.parse(localStorage.getItem("userData"))
  );
  const [verifiedPhone, setVerifiedPhone] = useState(normalizePhone(userData?.phone));
  const phoneExists = !!userData?.phone;
const [isPhoneVerified, setIsPhoneVerified] = useState(false);
const phoneRef = useRef(null);
const [otpSent, setOtpSent] = useState(false);
const [verifyLoading, setVerifyLoading] = useState(false);

const sendOTP = async (phone) => {
  const formattedPhone = `+1${phone.replace(/\D/g, "").slice(-10)}`;
  try {
    setVerifyLoading(true);
    const res = await fetch(ApiUrl + "/api/user/send-otp", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ phone:formattedPhone, user_id: userData.id ,type:"change_phone" }),
    });
  //  console.log("aslkdfasdfass",res)

    const data = await res.json();
  //  console.log("aslkdfasdf",data)
    if (data.smsstatus === "success") {
      toast.success(translations.EventsPortal.formModal.otpSentSuccess[language] || "OTP sent successfully!");
      setOtpSent(true);
    } else {
      toast.error(data.smsMessage || "Something went wrong!");
    }
  } catch (err) {
    toast.error(translations.alertMessages.wentWrong[language] || "Something went wrong!");
    // console.log("asdlfjkasdf",err)
  } finally {
    setVerifyLoading(false);
  }
};
const verifyOTP = async (values,setErrors) => {
  try {
    setIsLoading(true);

    const res = await fetch(ApiUrl + "/api/user/verifyOtp", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        email: userData?.email,
        otp:values.otp,
      }),
    });

    const data = await res.json();
  
    if (data.status === "success") {
      toast.success(translations.EventsPortal.formModal.phoneVerifiedSuccess[language] || "Phone verified successfully!");
      setIsPhoneVerified(true);
      setOtpSent(false);
      setVerifiedPhone(values.phone);
      setErrors({})
    } else {
      toast.error(data.message);
    }
  } catch (err) {
    toast.error(translations.alertMessages.wentWrong[language] || "Something went wrong!");
  } finally {
    setIsLoading(false);
  }
};
  const navigate = useNavigate();
  const userType = localStorage.getItem("userType");
  //   const userData = JSON.parse(localStorage.getItem("userData"));
  const { toggleLanguage } = useLanguage();
  console.log("userDatauserData",userData)
  const handleSubmit = async (values, { resetForm }) => {
   const formattedPhone = values.phone ? `+1${values.phone.replace(/\D/g, "").slice(-10)}` : "";
    if (values.name === "") {
      setValid(true);
      return;
    } else {
      const oldData = {
        name: userData.name,
        phone: userData.phone,
        user_language: userData.user_language,
        two_fa_email: userData?.two_fa_email,
        two_fa_phone: userData?.two_fa_phone,
      };
      const newData = {
        name: values.name,
        // phone: values.phone,
        phone: formattedPhone,
        user_language: values.user_language,
        two_fa_email:
          // values.two_fa_type === "email" || values.two_fa_type === "both"
          values.two_fa_type === "email" 

            ? "enabled"
            : "disabled",
        two_fa_phone:
          // values.two_fa_type === "phone" || values.two_fa_type === "both"
          values.two_fa_type === "phone" 

            ? "enabled"
            : "disabled",
      };
      if (JSON.stringify(oldData) !== JSON.stringify(newData)) {
        try {
          fetch(ApiUrl + "/api/user/edit-client-profile", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              name: values.name,
              phone: formattedPhone,
              // phone:
              //   (values.two_fa_type === "phone" || values.two_fa_type === "both")
              //     ? values.phone
              //     : userData.phone,
              user_language: values.user_language,
              two_fa_email:
                values.two_fa_type === "email" 
                  ? "enabled"
                  : "disabled",
              two_fa_phone:
                values.two_fa_type === "phone"
                  ? "enabled"
                  : "disabled",
            }),
          })
            .then((res) => {
              return res.json();
            })
            .then((data) => {
              toast.success(data.message);
              toggleLanguage();
              setUserData({
                ...userData,
                name: values.name,
                phone: formattedPhone,
                // phone:
                // (values.two_fa_type === "phone" || values.two_fa_type === "both")
                //   ? values.phone
                //   : userData.phone,
                user_language: values.user_language,
                two_fa_email:
                  values.two_fa_type === "email" 
                    ? "enabled"
                    : "disabled",
                two_fa_phone:
                  values.two_fa_type === "phone"
                    ? "enabled"
                    : "disabled",
              });

              localStorage.setItem(
                "userData",
                JSON.stringify({
                  ...userData,
                  name: values.name,
                  phone: formattedPhone,
                //   phone:
                // (values.two_fa_type === "phone" || values.two_fa_type === "both")
                //   ? values.phone
                //   : userData.phone,
                  user_language: values.user_language,
                  two_fa_email:
                    values.two_fa_type === "email" 
                      ? "enabled"
                      : "disabled",
                  two_fa_phone:
                    values.two_fa_type === "phone" 
                      ? "enabled"
                      : "disabled",

                })
              );
            });
        } catch (error) {
          toast.error(translations.alertMessages.wentWrong[language]);
        }
      } else {
        toast.error("Nothing to update");
      }
    }
  };
  // console.log("userData",userData)

const getValidationSchema = () =>
  Yup.object().shape({
    // name: Yup.string().required("Name could not be empty"),

    phone: Yup.string()
  .required(translations.alertMessages.phoneRequired[language]) // 👈 always required
  .test("len", translations.alertMessages.invalidPhone[language], (val) => {
    if (!val) return true;
    return val.replace(/\D/g, "").length === 10;
  })
  .test("verified", translations.EventsPortal.formModal.phoneVerifyRequired[language] || "Phone must be verified before saving.", (val) => {
    if (!val) return true;
    const phoneChanged = normalizePhone(val) !== verifiedPhone;
    return !phoneChanged || isPhoneVerified;
  }),
  });
  return (
    <div style={{ overflowX: "hidden" }}>
      {/* {externalUsers.includes(userType) && (
        <Navbar
          setToken={setToken}
          token={token}
          setIsDarkMode={setIsDarkMode}
          isDarkMode={isDarkMode}
          setIsLoading={setIsLoading}
        />
      )} */}
      <div
        className="Events row"
        style={{ minHeight: "80vh", overflow: "hidden" }}
      >
        <div class="container maincont col-5 mx-auto">
          <div id="app" class="appcountainer">
            <button
              type="button"
              className="btn btn-light mb-2"
              onClick={() =>
                navigate(
                  // externalUsers.includes(userType)
                  //   ? "/event-portal?page=view-submissons"
                  //   : 
                    "/event-portal?page=events"
                )
              }
            >
              <i class="bi bi-arrow-left-circle"></i>{" "}
              {
              // externalUsers.includes(userType)
              //   ? translations.viewClientForm.formListBtn[language]
                // : 
                translations.viewClientForm.eventListBtn[language]}
            </button>
            <div className="d-flex justify-content-between align-items-center my-2 ">
              <h2 id="h1">{pageTranslations.title[language]}</h2>
              <div>
                <button
                  className="admin-btn btn-lg btn-primary px-3 py-1"
                  type="button"
                  id="manage-notif-link"
                  data-bs-toggle="modal"
                  data-bs-target="#changePasswordModal"
                  fdprocessedid="3bt1kb"
                  data-bs-dismiss="offcanvas"
                  // onClick={() => }
                >
                  {translations["topAndsidebar"].changePassword[language]}
                </button>
              </div>
            </div>
            <div className="pb-4">
              <Formik
                initialValues={{
                  id: userData.id,
                  name: userData.name,
                  email: userData.email,
                  phone: normalizePhone(userData.phone),
                  user_language: userData.user_language,
                  // two_fa_type: userData?.two_fa_phone === "enabled"
                  //   ? userData?.two_fa_email === "enabled"
                  //     ? "both"
                  //     : "phone"
                  //   : userData?.two_fa_email === "enabled"
                  //     ? "email"
                  //     : "",
                  two_fa_type: userData?.two_fa_phone === "enabled"
                    ? "phone"
                    : userData?.two_fa_email === "enabled"
                      ? "email"
                      : "",
                }}
                validationSchema={getValidationSchema()}
                // validate={(values) => {
                //   const errors = {};
                //  const phoneChanged = values.phone !== userData.phone;
                //   if (
                //     (values.two_fa_type === "phone" || values.two_fa_type === "both" ) &&
                //     values.phone &&
                //     phoneChanged &&
                //     !isPhoneVerified
                //   ) {
                //     errors.phone = "Phone must be verified before saving.";
                //   }

                //   return errors;
                // }}
                onSubmit={handleSubmit}
                validateOnChange={true} 
              >
                {({ errors, touched, values, setValues ,setErrors,setFieldTouched }) =>{
                  const phoneChanged = values.phone !== normalizePhone(userData?.phone);
                  // console.log("userDatauserDatauserData",values.phone !== userData.phone)
                  return (
                  <Form>
                    <div
                      className={`form-floating ${
                        isDarkMode ? "dark-mode" : ""
                      }`}
                    >
                      <Field
                        type="text"
                        name="name"
                        className="form-control"
                        style={{
                          backgroundColor: isDarkMode ? "transparent" : "",
                          color: isDarkMode ? "#ffffff" : "#000000",
                          border: isDarkMode
                            ? "1px solid #495057"
                            : "1px solid #dee2e6",
                        }}
                        onChange={(e) => {
                          setValues({ ...values, name: e.target.value });
                          setValid(false);
                        }}
                      />
                      <ErrorMessage
                        name="name"
                        component="div"
                        className="error text-danger"
                      />
                      <label
                        htmlFor="floatingInput"
                        style={{
                          backgroundColor: isDarkMode ? "transparent" : "",
                          color: isDarkMode ? "#ffffff" : "#000000",
                          after: {
                            backgroundColor: isDarkMode ? "transparent" : "",
                          },
                        }}
                      >
                        {translations["commonFields"].name[language]}
                      </label>
                      {valid && (
                        <p className="text-danger">Name could not be empty</p>
                      )}
                    </div>
                    <div
                      className={`form-floating my-3 ${
                        isDarkMode ? "dark-mode" : ""
                      }`}
                      style={{ backgroundColor: isDarkMode ? "#4f5759" : "" }}
                      disabled
                    >
                      <Field
                        type="email"
                        name="email"
                        className="form-control"
                        disabled
                        style={{
                          backgroundColor: isDarkMode ? "transparent" : "",
                          color: isDarkMode ? "#ffffff" : "#000000",
                        }}
                      />
                      <ErrorMessage
                        name="email"
                        component="div"
                        className="error text-danger"
                      />
                      <label
                        htmlFor="floatingInput"
                        style={{
                          backgroundColor: isDarkMode ? "transparent" : "",
                          color: isDarkMode ? "#ffffff" : "#000000",
                        }}
                      >
                        {translations["commonFields"].email[language]}
                      </label>
                    </div>
                    <div
                      className={`form-floating my-3 ${
                        isDarkMode ? "dark-mode" : ""
                      }`}
                    >
                      {/* <Field
                        type="tel"
                        name="phone"
                        className="form-control"
                        innerRef={phoneRef}
                        style={{
                          backgroundColor: isDarkMode ? "transparent" : "",
                          color: isDarkMode ? "#ffffff" : "#000000",
                          border: isDarkMode
                            ? "1px solid #495057"
                            : "1px solid #dee2e6",
                        }}
                        onChange={(e) => {
                          setValues({ ...values, phone: e.target.value });
                          setIsPhoneVerified(false);
                          setOtpSent(false);
                        }}
                      /> */}
                        <Field
                          type="tel"
                          name="phone"
                          className="form-control"
                          innerRef={phoneRef}
                          value={formatPhoneDisplay(values.phone)}
                          style={{
                            backgroundColor: isDarkMode ? "transparent" : "",
                            color: isDarkMode ? "#ffffff" : "#000000",
                            border: isDarkMode ? "1px solid #495057" : "1px solid #dee2e6",
                          }}
                          // onChange={(e) => {
                          //   const raw = e.target.value;
                          //   const withoutPrefix = raw.replace(/^\+1\s?/, "");
                          //   const digitsOnly = withoutPrefix.replace(/\D/g, "").slice(0, 10);
                          //   setValues({ ...values, phone: digitsOnly });
                          //   setIsPhoneVerified(false);
                          //   setOtpSent(false);
                          // }}
                          onChange={(e) => {
                            const raw = e.target.value;
                            const withoutPrefix = raw.replace(/^\+1\s?/, "");
                            const digitsOnly = withoutPrefix.replace(/\D/g, "").slice(0, 10);

                            // If user types back the verified phone, restore verified state
                            if (digitsOnly === verifiedPhone) {
                              setIsPhoneVerified(true);
                            } else {
                              setIsPhoneVerified(false);
                            }
                            setFieldTouched("phone", true);
                            setValues({ ...values, phone: digitsOnly });
                            setOtpSent(false);
                          }}
                        />
                      <ErrorMessage
                        name="phone"
                        component="div"
                        className="error text-danger"
                      />
                      <label
                        htmlFor="floatingInput "
                        style={{
                          backgroundColor: isDarkMode ? "transparent" : "",
                          color: isDarkMode ? "#ffffff" : "#000000",
                        }}
                      >
                        {translations["commonFields"].phone[language]}
                      </label>
                    </div>
                {/* {(values.two_fa_type === "phone" || values.two_fa_type === "both" ) && ( */}
  <>
    {/* Show button if phone is entered but not verified */}
    { values.phone && phoneChanged && !isPhoneVerified && !otpSent && (
      <div className="d-flex justify-content-end align-items-center mt-2 mb-2 gap-2">
        {/* <span>{values.phone}</span> */}
        <button
          type="button"
          className="btn two-fa-screen-btn-light"
          onClick={() => sendOTP(values.phone)}
          // disabled={verifyLoading}
          disabled={verifyLoading || values.phone.length !== 10}
        >
          Verify Phone
        </button>
      </div>
    )}

    {/* OTP input and submit button */}
    {otpSent && !isPhoneVerified && (
      <div className="mt-1 d-flex gap-2 mb-3">
        <Field
          type="text"
          name="otp"
          placeholder="Enter OTP"
          className="form-control"
        />
        <button
          type="button"
          className="btn two-fa-screen-btn-light"
          onClick={() => verifyOTP(values,setErrors)}
          style={{width:'180px'}}
        >
          Submit OTP
        </button>
      </div>
    )}

    {/* Phone verified message */}
    {isPhoneVerified && (
      <div className="text-success mt-1 mb-3">
        ✓ {translations.EventsPortal.formModal.phoneVerified[language]}
      </div>
    )}
  </>
{/* )} */}
                    {
                      <div
                        className="designationDrop"
                        style={{
                          backgroundColor: isDarkMode ? "transparent" : "",
                          color: isDarkMode ? "#ffffff" : "#000000",
                          border: isDarkMode
                            ? "1px solid #495057"
                            : "1px solid #dee2e6",
                        }}
                      >
                        <label
                          class=""
                          style={{
                            marginTop: "-10px",
                            color: isDarkMode ? "#fff" : "#212529a6",
                          }}
                        >
                          {translations["commonFields"].language[language]}
                        </label>
                        <div
                          className={`form-floating ${
                            isDarkMode ? "dark-mode" : ""
                          }`}
                        >
                          {/* <Field as="select" name="userType" className="form-select">
                    <option value="">Select</option>
                    <option value="1">Admin</option>
                    <option value="2">Client</option>
                  </Field>
                  <ErrorMessage
                    name="userType"
                    component="div"
                    className="error text-danger"
                  /> */}

                          <Select
                            placeholder={
                              translations["dropdown"].selectLanguage[language]
                            }
                            name="user_language"
                            className="selectpicker"
                            maxMenuHeight={"80px"}
                            onChange={(selectedOption) =>
                              setValues({
                                ...values,
                                user_language: selectedOption.value,
                              })
                            }
                            defaultValue={[
                              {
                                label:
                                  userData.user_language === "en"
                                    ? translations.commonWords.english[language]
                                    : translations.commonWords.french[language],
                                value: userData.user_language,
                              },
                            ]}
                            aria-labelledby="dealership-name-quick"
                            // isClearable
                            options={[
                              {
                                label:
                                  translations.commonWords.english[language],
                                value: "en",
                              },
                              {
                                label:
                                  translations.commonWords.french[language],
                                value: "fr",
                              },
                            ]}
                            isSearchable
                            styles={{
                              input: (provided) => ({
                                ...provided,
                                color: isDarkMode ? "#ffffff" : "black", // Color of the text when typing
                              }),
                              control: (provided, state) => ({
                                ...provided,
                                color: isDarkMode ? "#ffffff" : "black",
                                backgroundColor: isDarkMode
                                  ? "transparent"
                                  : "",
                                border: state.isFocused
                                  ? "1px solid none"
                                  : "1px solid none", // Adjust the border color for focus
                                boxShadow: state.isFocused ? "none" : "none", // Bootstrap's box shadow for focus
                                borderRadius: ".25rem",
                                paddingTop: "0rem",

                                borderStyle: "none",
                                // backgroundColor: "transparent",
                                padding: "0px",
                                minHeight: "20px",
                                marginTop: "-8px",
                              }),
                              valueContainer: (provided) => ({
                                ...provided,
                                padding: "0rem 0.75rem", // Bootstrap's padding for the value container
                              }),
                              indicatorSeparator: (provided) => ({
                                ...provided,
                                display: "none", // Hide the indicator separator
                              }),

                              dropdownIndicator: (provided) => ({
                                ...provided,
                                svg: {
                                  fill: isDarkMode ? "#ffffff" : "#868686",
                                  width: "18px",
                                  height: "18px",
                                },
                                paddingRight: "10px",
                                // color: isDarkMode ? "#ffffff" : "#868686",
                              }),

                              menu: (provided) => ({
                                ...provided,
                                margin: "0", // Remove default margin
                                color: isDarkMode ? "#ffffff" : "black",
                                backgroundColor: isDarkMode
                                  ? "#1f2023"
                                  : "white",
                              }),
                              placeholder: (provided) => ({
                                ...provided,
                                color: isDarkMode ? "#ffffff" : "#333333", // Specify your desired color for the placeholder
                                // Additional styles for placeholder
                              }),
                              singleValue: (provided) => ({
                                ...provided,
                                color: isDarkMode ? "#ffffff" : "black",
                              }),
                              option: (provided, state) => ({
                                ...provided,
                                color: isDarkMode ? "#ffffff" : "black",
                                backgroundColor: state.isHovered
                                  ? "#80bdff"
                                  : isDarkMode
                                  ? "#1f2023"
                                  : "white",
                                ":hover": {
                                  backgroundColor: isDarkMode
                                    ? "#33DBB4"
                                    : "#33DBB4",
                                },
                              }),
                            }}
                          />
                        </div>
                      </div>
                    }
                    <div className="my-3" style={{marginLeft:'12px'}}>
                      <label 
                      style={{
                            marginTop: "-10px",
                            color: isDarkMode ? "#fff" : "#212529a6",
                          }}
                      >
                        {translations.EventsPortal.formModal.select2FA[language]}
                      </label>

                      <div className="d-flex gap-4 mt-1">

                        <label className="form-check-label d-flex align-items-center">
                          <Field
                            type="radio"
                            name="two_fa_type"
                            value="email"
                            className="form-check-input me-2"
                          />
                          {translations.EventsPortal.formModal.emailOption[language]}
                        </label>

                        <label className="form-check-label d-flex align-items-center">
                          <Field
                            type="radio"
                            name="two_fa_type"
                            value="phone"
                            className="form-check-input me-2"
                            onChange={() => {
                              setValues({ ...values, two_fa_type: "phone" });
                              setTimeout(() => phoneRef.current?.focus(), 100);
                            }}
                          />
                          {translations.EventsPortal.formModal.phoneOption[language]}
                        </label>

                        {/* <label className="form-check-label d-flex align-items-center">
                          <Field
                            type="radio"
                            name="two_fa_type"
                            value="both"
                            className="form-check-input me-2"
                            onChange={() => {
                              setValues({ ...values, two_fa_type: "both" });
                              setTimeout(() => phoneRef.current?.focus(), 100);
                            }}
                          />
                          Both
                        </label> */}

                      </div>
                    </div>

                    <div className="mt-4 d-flex justify-content-end ">
                      <button
                        className="admin-btn btn-lg btn-primary"
                        type="submit"
                        // onClick={() => }
                      >
                        {translations["commonFields"].submitBtn[language]}
                      </button>
                    </div>
                  </Form>
                ) }
              }
              </Formik>
            </div>
          </div>

          <ChangePasswordModal
            setIsLoading={setIsLoading}
            isDarkMode={isDarkMode}
          />
        </div>
      </div>
    </div>
  );
}

export default UserProfile;
